import { useEffect } from 'react';

interface OutsideClickHandlerProps {
  ref: React.RefObject<HTMLElement>;
  handler: () => void;
}

const useOutsideClick = ({ ref, handler }: OutsideClickHandlerProps) => {
  useEffect(() => {
    if (ref.current) {
      const handleClickOutside = (event: MouseEvent) => {
        // event.target gives the shadowRoot parent
        // we use composedPath which works with an "open" shadowRoot
        const shadowElements = event.composedPath();
        const shadowElement = shadowElements.length ? shadowElements[0] : null;
        if (
          ref.current &&
          shadowElement &&
          !ref.current.contains(shadowElement as Node)
        ) {
          handler();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [ref, handler]);
};

export default useOutsideClick;
